module.exports = __webpack_public_path__ + "media/bootstrap-icons/reddit-29a36e05.svg";